import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * OrDivider - "Or continue with" separator between the email/password form
 * and the OAuth buttons on the auth pages.
 */
const OrDivider: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="relative my-2">
      <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div className="w-full border-t border-gray-200" />
      </div>
      <div className="relative flex justify-center">
        <span className="bg-gray-50 px-3 text-sm text-gray-500">
          {t('common:auth.orContinueWith', 'Or continue with')}
        </span>
      </div>
    </div>
  );
};

export default OrDivider;
